// components/tabs/Scatter3DTab.jsx
// 全温度域 3D 数据散点云

import Plot3D from '../viz/Plot3D';
import { useSolPred } from '../../hooks/useSolPredStore';

export default function Scatter3DTab() {
  const {
    selectedSystem, allData3D, phaseList,
    autoRotate, setAutoRotate,
    selectedPoint, setSelectedPoint,
  } = useSolPred();

  return (
    <div className="canvas-card full fade-in">
      <div className="canvas-header">
        <div>
          <div className="canvas-title">三维散点云 · 3D Data Cloud</div>
          <div className="canvas-subtitle">
            {allData3D.length} 个数据点 · 全温度域 · 拖拽旋转 · 滚轮缩放
          </div>
        </div>
        <div className="canvas-tools">
          <button
            className={`tool-btn ${autoRotate ? 'active' : ''}`}
            onClick={() => setAutoRotate(v => !v)}
          >{autoRotate ? '⏸ 停止旋转' : '▶ 自动旋转'}</button>
          <button className="tool-btn">重置视角</button>
        </div>
      </div>
      <div className="diagram-box" style={{ minHeight: 500 }}>
        <Plot3D
          mode="scatter"
          system={selectedSystem}
          allData={allData3D}
          phaseList={phaseList}
          autoRotate={autoRotate}
          selectedPointId={selectedPoint?.id}
          onSelectPoint={(pt) => setSelectedPoint(pt)}
        />
      </div>
    </div>
  );
}
